export default __webpack_public_path__ + "locales/ko-KR/BackupCodesDialog.json?hash=482ee8c6c2d33031193620ad133e6d97";